import React from 'react'
import { useTranslation } from 'react-i18next'
import KibLabel from '@chewy/kib-label-react'

import {
  OrderDisplayStatus,
  OrderDisplayStatusToVariant,
} from '~/constants/orderStatusChip'

import '@chewy/kib-label-styles/dist/kib-label.css'

export interface OrderStatusChipProps {
  className?: string
  status: OrderDisplayStatus
}

export const OrderStatusChip = ({
  status,
  className,
}: OrderStatusChipProps) => {
  const { t } = useTranslation(['Common'])
  const variant = OrderDisplayStatusToVariant[status]

  // Map with translation calls - string literals required for i18next parser
  const OrderDisplayStatusToTranslationKey: Record<OrderDisplayStatus, string> =
    {
      [OrderDisplayStatus.APPROVED]: t('Common:ORDER_STATUS.APPROVED'),
      [OrderDisplayStatus.SHIPPED]: t('Common:ORDER_STATUS.SHIPPED'),
      [OrderDisplayStatus.DELIVERED]: t('Common:ORDER_STATUS.DELIVERED'),
      [OrderDisplayStatus.PENDING_PHARMACIST_REVIEW]: t(
        'Common:ORDER_STATUS.PENDING_PHARMACIST_REVIEW',
      ),
      [OrderDisplayStatus.DECLINED_PET_NEEDS_TO_BE_SEEN]: t(
        'Common:ORDER_STATUS.DECLINED_PET_NEEDS_TO_BE_SEEN',
      ),
      [OrderDisplayStatus.DECLINED_WRONG_PRODUCT]: t(
        'Common:ORDER_STATUS.DECLINED_WRONG_PRODUCT',
      ),
      [OrderDisplayStatus.DECLINED_NOT_A_CLINIC_PATIENT]: t(
        'Common:ORDER_STATUS.DECLINED_NOT_A_CLINIC_PATIENT',
      ),
      [OrderDisplayStatus.DECLINED_OTHER]: t(
        'Common:ORDER_STATUS.DECLINED_OTHER',
      ),
      [OrderDisplayStatus.PHARMACIST_DECLINED]: t(
        'Common:ORDER_STATUS.PHARMACIST_DECLINED',
      ),
      [OrderDisplayStatus.CANCELED]: t('Common:ORDER_STATUS.CANCELED'),
    }

  const label = OrderDisplayStatusToTranslationKey[status]

  return (
    <KibLabel className={className} variant={variant}>
      {label}
    </KibLabel>
  )
}

export default OrderStatusChip
